/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function openCustomPopup(_target_id) {
  const popup = document.getElementById(_target_id);
  const content = popup.querySelector(".c-popup__wrapper");

  popup.classList.add("is-show");
  content.classList.add("is-show");
  document.body.classList.add("is-popup-open");
}

function closeCustomPopup(_target_id) {
  const popup = document.getElementById(_target_id);
  const content = popup.querySelector(".c-popup__wrapper");
  popup.classList.remove("is-show");
  content.classList.remove("is-show");
  document.body.classList.remove("is-popup-open");

  // チェックボックスから起動した場合、チェックを外す
  if(document.querySelector("[data-gift_one_item_checkbox]")){
    document.querySelector("[data-gift_one_item_checkbox]").checked = false;
  
  }
}

function backgroundClick(event) {
  const popupList = document.querySelectorAll(".c-popup");
  popupList.forEach(popup => {
    if (event.target == popup) {
      closeCustomPopup(popup.id);
    }
  });
}

window.addEventListener('click', backgroundClick);

document.addEventListener('DOMContentLoaded', function() {
  const togglePasswordButton = document.querySelector('[data-action="toggle-password-form"]');
  
  if (togglePasswordButton) {
    const form = togglePasswordButton.closest('form');
    if (form) {
      const passwordInput = form.querySelector('input[type="password"]');
      
      if (passwordInput) {
        togglePasswordButton.addEventListener('click', function() {
          if (passwordInput.type === 'password') {
            passwordInput.type = 'text';
            togglePasswordButton.classList.add('is-open');
          } else {
            passwordInput.type = 'password';
            togglePasswordButton.classList.remove('is-open');
          }
        });
      }
    }
  }
});


/*
  【Fetch All Products】
  - Max 1000 products
*/
const fetchAllProductsFromSection = async () => {
  const fetchSectionName = "custom-get-products-data";
  const fetchUrlItems = [
    `/collections/all?sections=${fetchSectionName}&page=1`,
    `/collections/all?sections=${fetchSectionName}&page=2`,
    `/collections/all?sections=${fetchSectionName}&page=3`,
    `/collections/all?sections=${fetchSectionName}&page=4`,
  ];
  const allProducts = [];

  async function requestSection(sectionUrl) {
    const requestChangeOptions = {
      credentials: 'same-origin',
      method: 'GET'
    }

    const response = await fetch(sectionUrl,requestChangeOptions)
      .then(response => response.json())
      .then(content => {
        const dom_wrapper = document.createElement('div');
        dom_wrapper.innerHTML = content[fetchSectionName];

        const productList = dom_wrapper.querySelector('#shopify-section-custom-get-products-data');

        if(productList) {
          const productListJSON = JSON.parse(productList.textContent);
          return productListJSON;
        }

        // セクションが取れていない。商品0件（空配列）とは区別するため null を返す
        return null;
      })
      .catch(error => {
        console.error('Error:', error);
        return null;
      });

    return response;
  }

  // 落ちたら1回だけ取り直す。4本まとめて投げるので Shopify 側に絞られることがあり、
  // 1ページ落ちるとそのページの商品が丸ごと「無い」ことになるため。
  async function fetchItem(sectionUrl) {
    const first = await requestSection(sectionUrl);
    if (first) return first;

    return await requestSection(sectionUrl);
  }

  // 4ページのうち1つでも取れなければ不完全。呼び出し側がキャッシュするかの判断に使う
  let complete = true;

  try {
    // 並列処理でfetchを実行
    const results = await Promise.all(fetchUrlItems.map(urlItem => fetchItem(urlItem)));
    
    // 結果を統合
    results.forEach(result => {
      if (result) {
        allProducts.push(...result);
      } else {
        complete = false;
      }
    });
    
    // created_atでソート（降順：新しい商品が先）
    allProducts.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
  } catch (error) {
    console.error(error);
    complete = false;
  }

  // ※ リスティング商品は除外
  const filteredProducts = allProducts.filter(product => !product.listing_parent_flg && !product.listing_child_flg);
  return { products: filteredProducts, complete: complete };
}

/*
  【Fetch All Products（1ページにつき1回だけ取る）】
  - 全件取得は4リクエスト・数MBと重い。商品ページでは OTHER ART と「同じアートの商品」が
    DOMContentLoaded で同時に呼ぶため、素のまま使うと8リクエストになる。
  - 結果ではなく Promise を覚える。同時に呼ばれても取得を1回にまとめるため。
  - 4ページのどれかが取れなかったときは覚えない。欠けたカタログを使い回すと、
    本当は存在する商品が「無い」ことになり、両方のセクションが同時に欠けるため。
*/
let allProductsPromise = null;

const fetchAllProducts = () => {
  if (!allProductsPromise) {
    allProductsPromise = fetchAllProductsFromSection().then((result) => {
      if (!result.complete) {
        allProductsPromise = null;
      }
      return result.products;
    }).catch((error) => {
      allProductsPromise = null;
      throw error;
    });
  }

  return allProductsPromise;
}

/*
  【コレクション お気に入りバリエーション選択モーダル】
  - コレクション/検索ページの♡ボタンクリック時にバリエーション一覧モーダルを表示
  - 各バリエーションごとにお気に入り登録可能
*/
(function() {
  const MODAL_ID = 'c-multilikes-variant-popup';

  function getVariantImage(variant, product) {
    if (variant.featured_image && variant.featured_image.src) {
      return variant.featured_image.src;
    }
    if (product.image && product.image.src) {
      return product.image.src;
    }
    if (product.images && product.images.length > 0) {
      if (typeof product.images[0] === 'string') {
        return product.images[0];
      }
      return product.images[0].src || '';
    }
    return '';
  }

  function getVariantTitle(variant,product) {
    if(product.variants.length <= 1) {
      return product.title;
    }

    const parts = [];
    if (variant.option1) parts.push(variant.option1);
    if (variant.option2) parts.push(variant.option2);
    if (variant.option3) parts.push(variant.option3);
    return parts.join(' / ');
  }

  function buildModalHTML(product) {
    const variantsHTML = product.variants.map(function(variant) {
      const imgSrc = getVariantImage(variant, product);
      const title = getVariantTitle(variant,product);
      const variantUrl = '/products/' + product.handle + '?variant=' + variant.id;

      return '<li class="c-multilikes-variant-item">' +
        '<a class="c-multilikes-variant-item__link" href="' + variantUrl + '">' +
          '<img class="c-multilikes-variant-item__image" src="' + imgSrc + '" alt="' + title.replace(/"/g, '&quot;') + '">' +
          '<span class="c-multilikes-variant-item__title">' + title + '</span>' +
        '</a>' +
        '<button type="button" class="multilikes-product-btn add-favorite" data-multilikes-product-button data-product-id="' + product.id + '" data-variant-id="' + variant.id + '">' +
          '<svg class="icon-heart" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>' +
        '</button>' +
      '</li>';
    }).join('');

    return '<div class="c-popup" id="' + MODAL_ID + '">' +
      '<div class="c-popup__wrapper">' +
        '<button class="c-popup__close-btn" onclick="closeCustomPopup(\'' + MODAL_ID + '\')">✕</button>' +
        '<h3 class="c-popup__section-title">' + product.title + '</h3>' +
        '<div class="c-popup-contents">' +
          '<ul class="c-multilikes-variant-list">' + variantsHTML + '</ul>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  document.addEventListener('click', async function(e) {
    const btn = e.target.closest('[data-multilikes-collection-button]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();
    console.log("data-multilikes-collection-button",btn);

    // ローディング状態で二重クリック防止
    if (btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');

    try {
      const handle = btn.dataset.productHandle;
      if (!handle) return;

      const res = await fetch('/products/' + handle + '.json');
      if (!res.ok) throw new Error('Failed to fetch product');
      const data = await res.json();
      const product = data.product;

      // コレクションボタンに product ID を付与（ポップアップ内から参照するため）
      btn.dataset.productId = String(product.id);

      // バリエーションが1つ以下の場合はポップアップを表示せず直接お気に入り登録
      if (product.variants.length <= 1) {
        const variant = product.variants[0];
        const customerId = window.multilikesConfig?.customerId;

        if (!customerId) {
          // 未ログインの理由を示してから誘導する
          if (typeof window.requireLoginForWishlist === 'function') {
            window.requireLoginForWishlist();
          } else {
            window.location.href = '/account/login?return_url=' + encodeURIComponent(window.location.href);
          }
          return;
        }

        const defaultUrl = window.multilikesConfig?.defaultUrl;
        const isInWishlist = btn.classList.contains('remove-favorite');
        const action = isInWishlist ? 'remove' : 'add';

        btn.disabled = true;
        try {
          const toggleRes = await fetch(defaultUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: new URLSearchParams({
              customer_id: customerId,
              product_id: String(product.id),
              variant_id: String(variant.id),
              target_type: 'product',
              action: action
            })
          });

          if (toggleRes.ok) {
            const toggleData = await toggleRes.json();
            if (toggleData?.data?.isInWishlist) {
              btn.classList.add('remove-favorite');
              btn.classList.remove('add-favorite');
              btn.classList.add('is-active');
            } else {
              btn.classList.add('add-favorite');
              btn.classList.remove('remove-favorite');
              btn.classList.remove('is-active');
            }
          } else {
            alert('お気に入りの更新に失敗しました');
          }
        } finally {
          btn.disabled = false;
        }
        return;
      }

      // 既存モーダルがあれば削除して最新データで再生成
      const existingModal = document.getElementById(MODAL_ID);
      if (existingModal) {
        existingModal.remove();
      }

      // モーダル DOM を生成して body に挿入
      document.body.insertAdjacentHTML('beforeend', buildModalHTML(product));

      // モーダルを開く
      openCustomPopup(MODAL_ID);

      // お気に入りボタンを初期化
      if (typeof ProductWishlistButton !== 'undefined' && ProductWishlistButton.initAllButtons) {
        ProductWishlistButton.initAllButtons();
      }
    } catch (error) {
      console.error('Error opening variant wishlist modal:', error);
    } finally {
      btn.classList.remove('is-loading');
    }
  });
})();

/**
 * 商品カードの画像スライダー
 *
 * CSS の scroll-snap で横スワイプを実現し、JSは矢印・インジケータの制御だけを担う。
 * カードは検索結果やJS描画のカルーセルなど後から差し込まれる場合があるため、
 * 個別に初期化せず document へのイベント委譲で動かしている。
 */
(function () {
  var SLIDER = '[data-product-item-slider]';

  function getSlider(el) {
    var wrapper = el.closest('.ProductItem__ImageWrapper');
    return wrapper ? wrapper.querySelector(SLIDER) : null;
  }

  function currentIndex(slider) {
    var slide = slider.querySelector('.ProductItem__Slide');
    if (!slide || !slide.offsetWidth) return 0;
    return Math.round(slider.scrollLeft / slide.offsetWidth);
  }

  function scrollToIndex(slider, index) {
    var slide = slider.querySelector('.ProductItem__Slide');
    if (!slide) return;
    slider.scrollTo({ left: slide.offsetWidth * index, behavior: 'smooth' });
  }

  function sync(slider) {
    var wrapper = slider.closest('.ProductItem__ImageWrapper');
    if (!wrapper) return;

    var total = slider.querySelectorAll('.ProductItem__Slide').length;
    var index = currentIndex(slider);

    var dots = wrapper.querySelectorAll('[data-product-item-slider-dot]');
    for (var i = 0; i < dots.length; i++) {
      dots[i].classList.toggle('is-active', i === index);
    }

    var prev = wrapper.querySelector('[data-product-item-slider-prev]');
    var next = wrapper.querySelector('[data-product-item-slider-next]');
    if (prev) prev.hidden = index <= 0;
    if (next) next.hidden = index >= total - 1;
  }

  document.addEventListener('click', function (event) {
    var prev = event.target.closest('[data-product-item-slider-prev]');
    var next = event.target.closest('[data-product-item-slider-next]');
    var dot = event.target.closest('[data-product-item-slider-dot]');
    if (!prev && !next && !dot) return;

    var slider = getSlider(prev || next || dot);
    if (!slider) return;

    event.preventDefault();

    if (dot) {
      scrollToIndex(slider, parseInt(dot.getAttribute('data-slide-index'), 10) || 0);
    } else {
      scrollToIndex(slider, currentIndex(slider) + (next ? 1 : -1));
    }
  });

  // scroll はバブリングしないためキャプチャフェーズで拾う
  document.addEventListener(
    'scroll',
    function (event) {
      var target = event.target;
      if (!target || !target.matches || !target.matches(SLIDER)) return;
      sync(target);
    },
    true
  );
})();

/**
 * 横スクロールコンテナの自動送り
 *
 * Flickity が有効な画面幅では Flickity の autoPlay が動くため何もしない。
 * Flickity が無効（CSSの横スクロールで見せている画面幅）のときだけ、
 * scrollLeft を1枚ずつ進める。
 *
 * 対象: [data-auto-scroll]
 * 停止条件: ホバー中 / タッチ操作中 / タブが非表示 / 動きを減らす設定
 */
(function () {
  var containers = document.querySelectorAll('[data-auto-scroll]');
  if (!containers.length) return;

  var prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  Array.prototype.forEach.call(containers, function (container) {
    var interval = parseInt(container.getAttribute('data-auto-scroll-interval'), 10) || 4000;
    var paused = false;

    container.addEventListener('mouseenter', function () { paused = true; });
    container.addEventListener('mouseleave', function () { paused = false; });
    container.addEventListener('touchstart', function () { paused = true; }, { passive: true });

    setInterval(function () {
      // Flickity が有効な間は Flickity 側の autoPlay に任せる
      if (container.classList.contains('flickity-enabled')) return;
      if (paused || document.hidden) return;

      var item = container.querySelector('.Carousel__Cell');
      if (!item) return;

      var step = item.getBoundingClientRect().width;
      var maxScroll = container.scrollWidth - container.clientWidth;

      if (container.scrollLeft >= maxScroll - 1) {
        container.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        container.scrollBy({ left: step, behavior: 'smooth' });
      }
    }, interval);
  });
})();
